export const INPUT_BORDER_RADIUS = '50px'
export const MULTILINE_TEXT_MOBILE_BORDER_RADIUS = '25px'

export const PAGE_TOP_PADDING = { desktop: '50px', tablet: '20px', mobile: '20px' }
export const PAGE_BOTTOM_PADDING = { desktop: '50px', tablet: '50px', mobile: '50px' }
export const FOOTER_HEIGHT = { desktop: '180px', tablet: '240px', mobile: '390px' }
export const PAGE_MAX_WIDTH = { desktop: '1480px', tablet: '100%', mobile: '100%' }
export const PAGE_WIDTH = { desktop: '90%', tablet: '90%', mobile: '90%' }
export const HEADER_HEIGHT = { desktop: '80px', tablet: '80px', mobile: '80px' }
export const HEADER_BANNER_HEIGHT = { desktop: '450px', tablet: '350px', mobile: '250px' }
export const BEACH_PLAN_HEIGHT = { desktop: '80vh', tablet: '80vh', mobile: '50vh' }
